import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Heading, Flex, Box } from 'roo-ui/components';
import TextButton from 'components/TextButton';
import { clearFilters } from 'store/search/searchActions';
import { getFilterCount } from 'store/search/searchSelectors';

const ClearFilters = ({ hideTitle, textDecoration }) => {
  const dispatch = useDispatch();
  const filterCount = useSelector(getFilterCount);
  const isDisabled = filterCount === 0;
  return (
    <Flex justifyContent="space-between" alignItems="center" mr={4}>
      {!hideTitle && (
        <Box>
          <Heading.h2 fontSize="sm">Filter properties</Heading.h2>
        </Box>
      )}
      <Box>
        <TextButton
          data-testid="clear-filters-button"
          fontSize="sm"
          color="brand.primary"
          onClick={() => dispatch(clearFilters())}
          disabled={isDisabled}
          textDecoration={textDecoration}
        >
          Clear all filters
        </TextButton>
      </Box>
    </Flex>
  );
};

ClearFilters.propTypes = {
  hideTitle: PropTypes.bool,
  textDecoration: PropTypes.string,
};

ClearFilters.defaultProps = {
  hideTitle: false,
  textDecoration: 'underline',
};

export default ClearFilters;
